import React, { useState, useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import './ToggleSwitch.css';
import { ManagerlApi } from '../../API/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { FaTrash } from 'react-icons/fa'; // Import the trash icon from react-icons

const ShouldersWidthCalcTab = () => {
  const { isShouldersWidthCalcEnabled, setIsShouldersWidthCalcEnabled, setRunShouldersWidthCalc } =
    useFileContext();
  const [folderPath, setFolderPath] = useState('');
  const [parameters, setParameters] = useState({
    shoulders_class: 3,
    db: '',
    collection: '',
  });
  const [showCheckMark, setShowCheckMark] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState('');
  const [requests, setRequests] = useState([]);


  const extractFolderId = (url) => {
    const parts = url.split('/');
    return parts[parts.length - 1];
  };

  const getFormattedTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleRunShouldersWidthCalc = async () => {
    const folderId = extractFolderId(folderPath);
    if (!folderId) {
      console.error('Invalid folder URL');
      return;
    }

    const apiUrl = `${ManagerlApi}/shoulders-width/${folderId}`;
    console.log(apiUrl);

    setCurrentFolderId(folderId);
    setShowCheckMark(false);
    setTimeout(() => {
      setShowCheckMark(true);
      setTimeout(() => setShowCheckMark(false), 6000);
    }, 100);

    const startTime = getFormattedTime();
    const requestId = uuidv4();
    setRequests((prevRequests) => [
      ...prevRequests,
      { id: requestId, folderId, status: 'Sent', startTime },
    ]);

    setFolderPath('');

    try {
      const response = await axios.post(apiUrl, parameters, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const statusMessage = response.data.message || 'Task Completed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${statusMessage} ✅` }
            : request
        )
      );
    } catch (error) {
      console.error('Error during calculation!', error);

      const errorMessage = error.response?.data?.message || 'Task Failed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${errorMessage} ❌` }
            : request
        )
      );
    }
  };

  const handleParameterChange = (e) => {
    const { name, value } = e.target;
    setParameters((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  const handleDeleteRequest = (id) => {
    setRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== id)
    );
  };

  const handleClearAll = () => {
    setRequests([]);
  };

  useEffect(() => {
    setRunShouldersWidthCalc(() => handleRunShouldersWidthCalc);
  }, [folderPath, parameters, setRunShouldersWidthCalc]);

  return (
    <div>
      <div>
        <label>Folder Path</label>
        <input
          type='text'
          placeholder='Tiles Folder Id'
          value={folderPath}
          onChange={(e) => setFolderPath(e.target.value)}
        />
      </div>
      <div>
        <label>Shoulders Class</label>
        <input
          type='number'
          name='shoulders_class'
          value={parameters.shoulders_class}
          onChange={handleParameterChange}
        />
      </div>
      <div>
        <label>Database</label>
        <input
          type='text'
          name='db'
          placeholder='mongo db lane'
          value={parameters.db}
          onChange={handleParameterChange}
        />
      </div>
      <div>
        <label>Collection</label>
        <input
          type='text'
          name='collection'
          placeholder='mongo collection lane'
          value={parameters.collection}
          onChange={handleParameterChange}
        />
      </div>
      <div>
        <button onClick={handleRunShouldersWidthCalc}>
          Run Shoulders Width Calculation
        </button>
      </div>
      {showCheckMark && (
        <div className='check-mark'>Request {currentFolderId} Sent ✅</div>
      )}
      <div className='request-list'>
        <table>
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Status</th>
              <th>Start Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id}>
                <td>{request.folderId}</td>
                <td>{request.status}</td>
                <td>{request.startTime}</td>
                <td>
                  <button onClick={() => handleDeleteRequest(request.id)}>
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='clear-all-button' onClick={handleClearAll}>
          Remove All
        </button>
      </div>
    </div>
  );
};

export default ShouldersWidthCalcTab;
